// extracted by css-extract-rspack-plugin
export default {"menu":"menu-qnf96_","action":"action-ST2LYA","show":"show-d7AWXG"};